import { Team } from '@yandex-int/k-common/typings';

import { TEAM_BUILDER_ENTRY_STEPS } from 'common.components/team-builder/typings';

import * as constants from './constants';

export const toggleClassNameEditorModal = (isOpen: boolean) =>
    <const>{ type: constants.TOGGLE_CLASS_NAME_EDITOR_MODAL, isOpen };

export const toggleArchivateClassModal = (isOpen: boolean) =>
    <const>{ type: constants.TOGGLE_ARCHIVATE_CLASS_MODAL, isOpen };

export const finishClassCreation = (createdTeamId: number) =>
    <const>{ type: constants.FINISH_CLASS_CREATION, createdTeamId };

export const setShouldRedirect = (shouldRedirect: boolean, createdTeamId: number | null) =>
    <const>{ type: constants.SET_SHOULD_REDIRECT, shouldRedirect, createdTeamId };

export const setClassIdToDelete = (classId: number | null) =>
    <const>{ type: constants.SET_CLASS_ID_TO_DELETE, id: classId };

export const setClassItemToArchive = (classItem: Team | null) =>
    <const>{ type: constants.SET_CLASS_ITEM_TO_ARCHIVE, classItem };

export const startAddingNewStudentsList = (entryPoint: TEAM_BUILDER_ENTRY_STEPS = TEAM_BUILDER_ENTRY_STEPS.STUDENTS) =>
    <const>{ type: constants.START_ADDING_NEW_STUDENTS_LIST, entryPoint };

export const handleRedirectToCreatedClass = (classId: number) =>
    <const>{ type: constants.HANDLE_REDIRECT_TO_CREATED_CLASS, classId };
